export default class BlobUtility{

    //Parameters:
    ///b64Data = Base64String
    ///contentType = the mime type to set the type of file the Blob will be
    ///sliceSize =  the bytes to be process in each batch(loop).
    ///             512 bytes seems to be the ideal slice size for the performance wise per findings online
    //Process:
    ///Convert b64Data to its binary value using window.atob() function (ASCII to Binary)
    ///Get the Unicode value of each binary character:
    ////Loop through the Binary string in batches of 512.
    ////Next, use charCodeAt(i) to get the Unicode character.
    ////Last, add it to a working Uint8Array
    ///Once done looping, create the Blob from the byteArray with content type as specified by input parameter
    public static b64toBlob(b64Data, contentType: string, sliceSize: number = 512) {
        let byteCharacters = window.atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);

            // if 512 is bassed in as sliceSize the byteNumbers length will be 512
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    public static setDownloadClickEvent(url: string, fileName: string): void {
        const a = document.createElement('a');

        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', fileName);

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
}
